import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

// Lazy load za Home i AgentPanel
const Home = React.lazy(() => import('./components/Home/Home'));
const AgentPanel = React.lazy(() => import('./components/Home/AgentPanel'));

const App = () => {
  // Hardcoded "authentication" za agenta
  const isAgent = true; // Promeni ovo u stvarnu proveru ako želiš bolju sigurnost

  return (
    <div className="flex flex-col min-h-screen">
      <Router>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            {/* Ruta za Home komponentu */}
            <Route path="/" element={<Home />} />
            
            {/* Ruta za Agent Panel */}
            <Route
              path="/agent-panel"
              element={isAgent ? <AgentPanel /> : <Navigate to="/" />}
            />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
};

export default App;
